import React from "react";

// Matches the f-20 icon size used in the timeline avatar circle
const IMAGE_SIZE = 28;

interface IProps {
  icon: string;
  imageSrc?: string;
}

const ActivityIcon = ({ icon, imageSrc }: IProps) =>
  imageSrc ? (
    <img
      src={imageSrc}
      alt=""
      width={IMAGE_SIZE}
      height={IMAGE_SIZE}
      style={{ objectFit: "contain" }}
    />
  ) : (
    <i className={`${icon} f-20`}></i>
  );

export default ActivityIcon;
